import Layout from '@views/Layout/Layout'

/**
 * Wrapper/helper to handle rendering the correct layout based on the feature flag.
 * This can stay when the feature flag is fully rolled out.
 *
 * Note: when the FF is removed, delete the LayoutOld and SidebarOld folders/files
 */
export default function LayoutManager() {
	return <Layout />
}
